import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useSidebar } from '@context/SidebarContext'

import { Tooltip } from '@ui/components/Tooltip'
import { ChevronIcon } from '@ui/icons/Chevron.icon'

import { MenuLink } from '@shared/components/Navigation/MenuLink'
import { MenuSection } from '@shared/components/Navigation/menuSections/useMenuSections'

import styles from './SidebarItem.module.scss'

export const SidebarToggle: React.FC = () => {
  const { t } = useTranslation()
  const { isExpanded, toggleSidebar } = useSidebar()

  const buttonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!buttonRef.current) return

    buttonRef.current.setAttribute('data-tour-target', 'wallets.expandAndCollapse')
  }, [])

  const section: MenuSection = {
    id: 'sidebar-toggle',
    label: t('Tabs.Collapse'),
    icon: isExpanded ? ChevronIcon.Left : ChevronIcon.Right,
  }

  const button = (
    <MenuLink
      section={section}
      isVisible={isExpanded}
      className={styles.sideBarItem}
      onClick={toggleSidebar}
      buttonRef={buttonRef}
    />
  )

  if (!isExpanded) {
    return (
      <Tooltip content={t('Tabs.Unfold the navigation')} direction='right'>
        {button}
      </Tooltip>
    )
  }

  return button
}
